import { useCallback } from 'react';
import { createGlobalState } from 'react-use';

const useVerifyState = createGlobalState({
	status: false,
	title: '',
	message: '',
	onCancel: null,
	onConfirm: null,
});

const useVerify = () => {
	const [verifyState, setVerifyState] = useVerifyState();

	const closeVerify = useCallback(() => {
		setVerifyState((currentState) => {
			return {
				...currentState,
				status: false,
			}
		});
	}, [setVerifyState]);

	const onClickCancel = useCallback(() => {
		if (verifyState.onCancel) verifyState.onCancel();
		closeVerify();
	}, [closeVerify, verifyState]);

	const onClickConfirm = useCallback(() => {
		if (verifyState.onConfirm) verifyState.onConfirm();
		closeVerify();
	}, [closeVerify, verifyState]);

	const sendVerify = useCallback(({ title, message, onCancel, onConfirm }) => {
		setVerifyState({
			status: true,
			title: title || '',
			message: message || '',
			onCancel: onCancel,
			onConfirm: onConfirm,
		});
	}, [setVerifyState]);

	return { sendVerify, verifyState, setVerifyState, onClickCancel, onClickConfirm };
}

export default useVerify;